import { render, staticRenderFns } from "./SearchAddress.vue?vue&type=template&id=aa8c0db4"
import script from "./SearchAddress.vue?vue&type=script&lang=js"
export * from "./SearchAddress.vue?vue&type=script&lang=js"
import style0 from "./SearchAddress.vue?vue&type=style&index=0&id=aa8c0db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports